import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { name: '明星八卦', href: '/category/mingxing-bagua' },
  { name: '网红黑料', href: '/category/wanghong-heiliao' },
  { name: '综艺爆料', href: '/category/zongyi-baoliao' },
  { name: '影视吃瓜', href: '/category/yingshi-chigua' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-lg border-b border-secondary-800/40'
            : 'bg-transparent'
        }`}
      >
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="flex items-center justify-between h-16 md:h-18">
            <div className="hidden md:flex items-center gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                    location.pathname === link.href
                      ? 'text-primary-400'
                      : 'text-foreground-300/60 hover:text-foreground-200'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            <div className="absolute left-1/2 -translate-x-1/2">
              <Link
                to="/"
                className="text-xl md:text-2xl font-heading font-bold text-foreground-50 tracking-wider whitespace-nowrap"
              >
                爆料吃瓜
              </Link>
            </div>

            <div className="hidden md:flex items-center gap-5">
              <Link
                to="/about"
                className="text-sm text-foreground-300/60 hover:text-foreground-200 transition-colors duration-200 whitespace-nowrap"
              >
                投稿入口
              </Link>
              <button
                type="button"
                className="w-9 h-9 flex items-center justify-center text-foreground-300/60 hover:text-foreground-200 transition-colors duration-200"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
              <Link
                to="/about"
                className="px-5 py-2 rounded-full bg-foreground-50 text-background-950 text-sm font-medium hover:bg-foreground-200 transition-colors duration-200 whitespace-nowrap"
              >
                登录
              </Link>
            </div>

            <button
              type="button"
              className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-300 hover:text-foreground-100"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-100/98 backdrop-blur-lg border-t border-secondary-800/40">
            <div className="px-4 py-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`text-sm py-2 transition-colors duration-200 ${
                    location.pathname === link.href
                      ? 'text-primary-400'
                      : 'text-foreground-300/70 hover:text-foreground-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <div className="border-t border-secondary-800/40 pt-3 mt-1 flex items-center justify-between">
                <Link
                  to="/about"
                  className="text-sm text-foreground-300/70 hover:text-foreground-100 transition-colors"
                >
                  投稿入口
                </Link>
                <Link
                  to="/about"
                  className="px-5 py-2 rounded-full bg-foreground-50 text-background-950 text-sm font-medium hover:bg-foreground-200 transition-colors"
                >
                  登录
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}